import type { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { RootState } from 'redux/store';

interface TypeAuth {
  children: ReactNode;
  roles?: string[];
}

export const RequireAuth: FC<TypeAuth> = ({ children, roles }) => {
  const location = useLocation();
  const isAuth = useSelector((state: RootState) => Boolean(state.authSlice.token));
  const userRole = localStorage.getItem('role');

  if (!isAuth) {
    return <Navigate to='/' state={{ from: location }} replace />;
  }

  if (roles && roles.length > 0) {
    if (!userRole || !roles.includes(userRole)) {
      const defaultPath = userRole === 'director' ? '/orders' : '/beneficiaries';
      return <Navigate to={defaultPath} replace />;
    }
  }

  return <>{children}</>;
};
